<script setup>
const props = defineProps({
    hit: {
        type: Object,
        required: true,
    },
});
</script>

<template>
    <MessLink :href="hit.url" class="block-algolia-hit" :label="hit.title">
        <strong class="h6" v-if="hit.model || hit.type">{{ hit.model || hit.type }}</strong>
        <MessHtml class="title h3" v-if="hit.title" :html="hit.title" />
    </MessLink>
</template>

<style lang="scss">
html {
    body {
        .block-algolia-hit {
            user-select: auto;
            transition: 250ms ease-in-out;

            &:hover {
                .title {
                    border-bottom: 1px solid  var(--cream);
                }
            }

            .h6 {
                font-size: 0.75rem;
                text-transform: uppercase;
                color: var(--orange-lighter);
                letter-spacing: 0.0375rem;
                font-weight: 400;
            }

            .title {
                color: var(--cream);
                font-size: 1.25rem;
                font-weight: 300;
                line-height: 1.75rem;
                display: flex;
                width: fit-content;
                border-bottom: 1px solid transparent;
            }
        }
    }
}
</style>
